import apiClient from '../lib/apiClient';

const departmentsService = {
  // Get all departments
  getDepartments: async (filters = {}) => {
    try {
      const result = await apiClient.get('/departments', filters);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch departments' };
    }
  },

  // Get department by ID
  getDepartment: async (id) => {
    try {
      const result = await apiClient.get(`/departments/${id}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch department' };
    }
  },

  // Create department
  createDepartment: async (data) => {
    try {
      const result = await apiClient.post('/departments', data);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to create department' };
    }
  },

  // Update department
  updateDepartment: async (id, data) => {
    try {
      const result = await apiClient.put(`/departments/${id}`, data);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to update department' };
    }
  },

  // Delete department
  deleteDepartment: async (id) => {
    try {
      const result = await apiClient.delete(`/departments/${id}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to delete department' };
    }
  }
};

export default departmentsService;

